import React from 'react';
import { resourceApi } from '../../utils/fetchUtil';
import Paper from 'material-ui/Paper';
import { ListItem} from 'material-ui/List';
import AvatarIcon from '../../Components/IconRender'
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

const dasStyle = {padding:5, marginTop:7,  marginBottom:15};

class Topics extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            topicSelected: "",
            selection: 1,
            topics: []
        };
    }
    
    componentDidMount() {
        this.loadTopics();
    }
    
    loadTopics(){
        
        var self = this;
        
        let config = {
            method: 'get',
            url: `member/message/topics`
        };
        
        self.setState({fetching: true});

        resourceApi(config) 
        .then(function (response) {
            self.setState({fetching: false, topics: response.data});
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    makeSelection = (id, text) => {
        this.props.selectTopic(id, text);
    }

    

    render() {

        return (
            <div>
                <Paper>
                    <div style={{textAlign:'center', padding: '15px 0 5px 0'}} >
                        <h3>How can we help you today?</h3>
                        <p>Please select a topic below</p>
                    </div>
                </Paper>
                {/* <Card>
                    <CardHeader
                        title={<h4 style={{margin:5}}>Select a topic</h4>}
                        avatar={<Avatar> <div className="care-guide-small" /> </Avatar>} 
                    />
                </Card> */}

                <div className="container" >
            
                    {this.state.topics.map((m, index) => (
                        <Paper key={index} style={dasStyle}>
                    
                            <ListItem
                                leftAvatar={ <div>
                                  <AvatarIcon icon={m} />
                                  </div>
                                }
                                primaryText={m.Name} 
                                onClick={ () => this.makeSelection(m.SystemMessageTopicID, m.Name)}
                                rightIcon={<ChevronRight />}
                                className="trueno"
                            />
                        </Paper>
                    ))}

                

                </div>
            </div>
        );
    }
};
export default Topics;

           



// WEBPACK FOOTER //
// ./src/Components/Messaging/Topics.js